import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query';
import { SerializedError } from '@reduxjs/toolkit';

export const instanceOfFetchBaseQueryError =(data:any):data is FetchBaseQueryError => {
    return "status" in data && ( "data" in data || "error" in data || "originalStatus" in data )
}

export const instanceOfFetchSerializedError = (data:any):data is SerializedError => {
    return "name" in data || "message" in data || "stack" in data || "code" in data
}
